import {
  Button,
  Col,
  Drawer,
  Dropdown,
  Form,
  Image,
  Menu,
  Popconfirm,
  Row,
  Select
} from "antd";
import Card from "components/card";
import * as appRoutes from "config/routes.config";
import React, { FC, useState } from "react";
//!IMAGES
import { DownOutlined } from "@ant-design/icons";
import BackIconBlack from "../../../../assets/images/app/backBlack.svg";

//!STYLES
import { Link, useNavigate } from "react-router-dom";
import CardChallenge from "screens/teacher/Room/components/CardChallenge";
import CardQuizz from "screens/teacher/Room/components/cardQuizz/cardQuizz";
import s from "./assets/card.module.css";

//!STYLES
import AppDrawer from "components/appDrawer";
import DrawerPublications from "../drawerPublications";
import styles from "./assets/drawer.module.css";

type Props = {
  classroom?: object | any;
  onArchiveClass?: () => void;
  onDeleteClass?: () => void;
  isLoading?: boolean;
};

const CardClasses: FC<Props> = ({ classroom, onArchiveClass, onDeleteClass, isLoading }) => {
  //!STATE
  const [isDrawerChallenge, setIsDrawerChallenge] = useState<boolean>(false);
  const [openDrawerPublications, setOpenDrawerPublications] = useState(false);
  const [childrenDrawerVisble, setChildrenDrawerVisible] =
    useState<boolean>(false);
  const { Option } = Select;

  //!FUNCTION
  const handleShowChildrenDrawer = () =>
    setChildrenDrawerVisible(!childrenDrawerVisble);

  const navigate = useNavigate();

  const handleSeeClass = () => {
    navigate(`${appRoutes.TEACHER_ROOMS}/${classroom?._id}`);
  }

  const menu = (
    <Menu>
      <Menu.Item key="see" onClick={handleSeeClass}>
        Voir la classe
      </Menu.Item>

      {classroom?.status === "PUBLISHED" && <Menu.Item key="archive">
        <Popconfirm
          title="Êtes-vous sûr de vouloir archiver cette classe ?"
          onConfirm={onArchiveClass}
          okText="Oui"
          cancelText="Non"
        >
          <span>Archiver la classe</span>
        </Popconfirm>
      </Menu.Item>}

      {classroom?.status === "PUBLISHED" && <Menu.Item key="delete">
        <Popconfirm
          title="Êtes-vous sûr de vouloir supprimer cette classe ?"
          onConfirm={onDeleteClass}
          okText="Oui"
          cancelText="Non"
        >
          <span style={{ color: "red" }}>Supprimer la classe</span>
        </Popconfirm>
      </Menu.Item>}
    </Menu>
  );

  const formattedExpirationDate = (stringDate: string) => {
    const formattedDate = new Intl.DateTimeFormat("fr-FR", {
      day: "2-digit",
      month: "long",
      year: "numeric",
    }).format(stringDate ? new Date(stringDate) : new Date());

    return formattedDate;
  }

  return (
    <React.Fragment>
      <Link to={`${appRoutes.TEACHER_ROOMS}/${classroom?._id}`}>
        <Card className={s.card}>
          <div className={s.card__content}>
            <div
              style={{
                background: `
              ${classroom?.status === "PUBLISHED"
                    ? "#60CD95"
                    : classroom?.status === "PENDING"
                      ? "#34bdd6"
                      : classroom?.status === "ARCHIVED"
                        ? "#FFDCAB"
                        : ""
                  }`,
              }}
              className={s.ribbon}
            >
              <span style={{
                color: `
              ${classroom?.status === "PUBLISHED"
                    ? "#FFF"
                    : classroom?.status === "PENDING"
                      ? "#FFF"
                      : classroom?.status === "ARCHIVED"
                        ? "#9A6111"
                        : ""
                  }`,
              }}>
                {classroom?.status === "PENDING" && "A venir"}
                {classroom?.status === "PUBLISHED" && "En cours"}
                {classroom?.status === "ARCHIVED" && "Archivée"}
              </span>
            </div>

            <div style={{ fontSize: "14px", color: "#393e3e", width: "70%", marginLeft: "15px", textAlign: "center" }}>
              <span>{classroom?.title || classroom?.name || ""}</span>
            </div>

            <div style={{ fontSize: "12px", marginTop: "10px", fontWeight: 500 }}>
              <span>{classroom?.classType === "OPEN" ? "Classe ouverte" : classroom?.organism ? "Classe organisme" : "Pack prédéfini"}</span>
            </div>

            <div style={{ fontSize: "12px", fontWeight: 400 }}>
              <span>{classroom?.registeredStudents?.length > 1 ? classroom?.registeredStudents?.length + " élèves" : classroom?.registeredStudents?.length + " élève"}</span>
            </div>

            {/* {classroom?.classType === "PACK_PREDEFINED" && <div style={{ fontSize: "12px", fontWeight: 400 }}>
              <span>{classroom?.hoursSpent || 0 + "/" + classroom?.teacherCreditsSpent + " heures effectuées"}</span>
            </div>} */}

            {classroom?.classType === "PACK_PREDEFINED" && <div style={{ fontSize: "12px", fontWeight: 400 }}>
              <span>{classroom?.teacherCreditsCost + " Crédits"}</span>
            </div>}

            {/* {classroom?.classType === "PACK_PREDEFINED" && <div style={{ fontSize: "12px", fontWeight: 600, marginTop: "0px", marginLeft: "10px" }}>
              <span>{"Date d'expiration : " + formattedExpirationDate(classroom?.teacherCreditsExpiry)}</span>
            </div>} */}

            {classroom?.classType === "PACK_PREDEFINED" && <div style={{ position: "absolute", bottom: "100px", height: "1px", width: "75%", background: "#C0C0C0", marginLeft: "15px" }}></div>}
            {classroom?.classType === "PACK_PREDEFINED" && <div style={{ position: "absolute", bottom: "80px", fontSize: "12px", fontWeight: 600, display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "space-between", width: "80%", paddingLeft: "20px" }}>
              <span>{"Revenu total:"}</span>
              <span>{classroom?.teacherCreditsSpent * classroom?.teacherCreditsCost + "€"}</span>
            </div>}
            {classroom?.classType === "PACK_PREDEFINED" && <div style={{ position: "absolute", bottom: "60px", fontSize: "12px", fontWeight: 400, display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "space-between", width: "80%", paddingLeft: "20px" }}>
              <span>{"Tarif horaire"}</span>
              <span>{classroom?.teacherCreditsCost + "€/h"}</span>
            </div>}

            <div style={{ position: "absolute", bottom: "30px" }}>
              <Dropdown overlay={menu} trigger={["click"]}>
                <Button className={s.dropdown} disabled={isLoading} loading={isLoading}>
                  Actions <DownOutlined />
                </Button>
              </Dropdown>
            </div>
          </div>
        </Card>
      </Link>

      <AppDrawer
        title={false}
        onClose={() => setIsDrawerChallenge(!isDrawerChallenge)}
        visible={isDrawerChallenge}
      >
        <div className={styles.__first_drawer}>
          <div className={styles.drawer__content}>
            <div className={styles.drawer___header}>
              <h3>Challenger cette classe</h3>
            </div>

            <Form name="create-room" autoComplete="off">
              <div className={styles.filter}>
                {/* <div className={styles.filter__left}></div> */}

                <div className={styles.select__field}>
                  <Row justify="center">
                    <Col className={styles.custom__select}>
                      <Form.Item name="levelId">
                        <Select
                          placeholder="Choisis un niveau"
                          allowClear
                          // loading={levels.loading}
                          bordered={false}
                          className={`${styles.select}`}
                        >
                          {/* {levels.items.map((level) => (
                              <Option key={level._id} value={level._id}>
                                {level.title}
                              </Option>
                            ))} */}
                        </Select>
                      </Form.Item>
                    </Col>

                    <Col className={styles.custom__select}>
                      <Form.Item name="levelId">
                        <Select
                          placeholder="Choisis un niveau"
                          allowClear
                          // loading={levels.loading}
                          bordered={false}
                          className={`${styles.select}`}
                        >
                          {/* {levels.items.map((level) => (
                              <Option key={level._id} value={level._id}>
                                {level.title}
                              </Option>
                            ))} */}
                        </Select>
                      </Form.Item>
                    </Col>

                    <Col>
                      <Form.Item name="topicId">
                        <Select
                          placeholder="Choisis une matière"
                          allowClear
                          // loading={topics.loading}
                          bordered={false}
                          className={`${styles.select}`}
                        >
                          {/* {topics.items.map((topic) => (
                              <Option key={topic._id} value={topic._id}>
                                {topic.title}
                              </Option>
                            ))} */}
                        </Select>
                      </Form.Item>
                    </Col>
                  </Row>
                </div>
              </div>

              <div className={styles.__row}>
                <CardChallenge
                  handleShowChildrenDrawer={handleShowChildrenDrawer}
                />
                <CardChallenge
                  handleShowChildrenDrawer={handleShowChildrenDrawer}
                />
              </div>
            </Form>
            <div
              className={styles.__first_back}
              onClick={() => setIsDrawerChallenge(!isDrawerChallenge)}
            >
              <Image preview={false} src={BackIconBlack} width={40} />
            </div>
          </div>
        </div>

        <Drawer
          title={false}
          placement="right"
          width={"70%"}
          onClose={handleShowChildrenDrawer}
          visible={childrenDrawerVisble}
          closable={false}
        >
          <div className={styles.__first_drawer}>
            <div className={styles.drawer__content}>
              <div className={styles.drawer___header}>
                <h3>Aperçu du quiz </h3>
              </div>

              <Form
                name="create-room"
                // labelCol={{ span: 7 }}
                // wrapperCol={{ span: 17 }}
                autoComplete="off"
              // validateTrigger={["onFinish"]}
              // onFinish={addCourse}
              // form={addCourseForm}
              >
                <div className={styles.__overflow__Y}>
                  <div className={styles.content}>
                    <div className={styles.faq}>
                      <h4>
                        Dans quel cas une écriture fractionnaire est-elle une
                        fraction ?
                      </h4>
                    </div>

                    <CardQuizz />
                    <CardQuizz />
                    <CardQuizz />
                  </div>
                  <div className={styles.content}>
                    <div className={styles.faq}>
                      <h4>
                        Dans quel cas une écriture fractionnaire est-elle une
                        fraction ?
                      </h4>
                    </div>

                    <CardQuizz />
                    <CardQuizz />
                    <CardQuizz />
                  </div>
                  <div className={styles.content}>
                    <div className={styles.faq}>
                      <h4>
                        Dans quel cas une écriture fractionnaire est-elle une
                        fraction ?
                      </h4>
                    </div>

                    <CardQuizz />
                    <CardQuizz />
                    <CardQuizz />
                  </div>
                </div>
              </Form>
              <div
                className={styles.__first_back}
                onClick={() => setChildrenDrawerVisible(!childrenDrawerVisble)}
              >
                <Image preview={false} src={BackIconBlack} width={40} />
              </div>
            </div>
          </div>
        </Drawer>
      </AppDrawer>

      <DrawerPublications
        open={openDrawerPublications}
        currRoom={classroom}
        setOpen={setOpenDrawerPublications}
        currLevel={classroom.level}
      />
    </React.Fragment>
  );
};

export default CardClasses;
